import APIService from '@/services/APIService.js';

export default {
  listarUsuariosEncaminhamento() {
    return APIService.apiCall().get('/gestao-bdgds-erros/tarefas/usuarios-encaminhamento');
  },

  listarValidacoesBdgd(erroId) {
    return APIService.apiCall().get(`/gestao-bdgds-erros/tarefas/${erroId}/validacoes-bdgd`);
  },

  listarExtracoesBdgd(bdgdVersaoId, entidade) {
    return APIService.apiCall().get('/gestao-bdgds-erros/tarefas/extracoes-bdgd', {
      params: {
        bdgd_versao_id: bdgdVersaoId,
        entidade
      }
    });
  },

  baixarArquivoEvidencia(erroId, params) {
    return APIService.apiCall().get(`/gestao-bdgds-erros/tarefas/${erroId}/arquivos`, {
      params,
      responseType: 'blob',
      timeout: 60 * 60 * 1000
    });
  },

  encaminharTarefa(erroId, dados) {
    return APIService.apiCall().post(`/gestao-bdgds-erros/tarefas/${erroId}/encaminhar`, dados);
  },

  encaminharTarefasEmLote(dados) {
    return APIService.apiCall().post('/gestao-bdgds-erros/tarefas/encaminhar-lote', dados);
  },

  salvarAnalise(erroId, dados) {
    return APIService.apiCall().put(`/gestao-bdgds-erros/tarefas/${erroId}/analise`, dados);
  },

  concluirAnalise(erroId, dados) {
    return APIService.apiCall().post(`/gestao-bdgds-erros/tarefas/${erroId}/analise/concluir`, dados);
  },

  justificarTarefa(erroId, dados) {
    return APIService.apiCall().post(`/gestao-bdgds-erros/tarefas/${erroId}/justificar`, dados);
  },

  executarCorrigirPrimeiro(erroId, dados) {
    return APIService.apiCall().post(`/gestao-bdgds-erros/tarefas/${erroId}/corrigir-primeiro`, dados);
  },

  listarAjustesCorrigirPrimeiro(erroId, tipos) {
    return APIService.apiCall().get(`/gestao-bdgds-erros/tarefas/${erroId}/ajustes`, {
      params: { tipos }
    });
  },

  encerrarTarefa(erroId, dados) {
    return APIService.apiCall().post(`/gestao-bdgds-erros/tarefas/${erroId}/encerrar`, dados);
  },

  buscarTarefa(tarefaId) {
    return APIService.apiCall().get(`/gestao-bdgds-erros/tarefas/${tarefaId}`);
  }
};
